import { AccessClient } from "./axiosInstance.js";

/**
 * 퀘스트를 완료한 정보를 제거해서 퀘스트를 미완료 상태로 만듭니다. 
 * @param {*} param0 
 * @returns 
 */
export const deleteCompleteQuest = async ({ id }) => {
  try {
    const response = await AccessClient.delete(`/api/completeQuests/${id}`);
    const {
      status,
      data: { data, message },
    } = response;

    return { status, result: data.result, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};

